import { render, staticRenderFns } from "./HTMLEditor.vue?vue&type=template&id=498aafd8"
import script from "./HTMLEditor.vue?vue&type=script&lang=ts"
export * from "./HTMLEditor.vue?vue&type=script&lang=ts"
import style0 from "./HTMLEditor.vue?vue&type=style&index=0&id=498aafd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports